import { css } from '@emotion/css';
import { fontStyle } from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	fontStyle({
		...styles?.typography,
		textAlign: styles?.textAlignment,
		color: styles?.color,
	});

const getStyles = (styles) => css(getDynamicStyles(styles));

export { getStyles };
